import {
    Component,
    ElementRef,
    NgZone,
    OnInit,
    ViewChild,
    OnDestroy,
    QueryList,
    ViewChildren,
    AfterViewInit
} from '@angular/core';
import { MapTypeStyle, AgmCircle, LatLngBounds } from '@agm/core';
import { MapStyles } from '@core/store/agm-style';
import {
    FormGroup,
    FormBuilder,
    Validators,
    AbstractControl,
    FormControl
} from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { AppConfigService } from '@core/services/config.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { LocalService } from '../local.services';
import { DataStep1 } from './data';
import { Subject, Observable, fromEvent } from 'rxjs';
import {
    takeUntil,
    startWith,
    map,
    debounceTime,
    distinctUntilChanged
} from 'rxjs/operators';
import { AppUtils } from '@core/appUtils';
import { Ubigeo } from '@core/models/local.model';
import { ScrollService } from '../scroll.services';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { GeneralData } from '@core/store/general';
import { AppFormPrivacityComponent } from '../../authentication/register/privacity/privacity.component';
import { MIN_LOCAL_AREA } from '../../../.././../../environments/config';
declare var google: any;

export interface User {
    name: string;
}

export interface Store {
    latitude: number;
    longitude: number;
}

export interface SearchZone {
    latitude: number;
    longitude: number;
}

@Component({
    selector: 'app-step-1',
    templateUrl: './step1.component.html',
    styleUrls: ['./step1.component.scss']
})
export class AppStep1Component implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('circle', { read: AgmCircle }) circle: AgmCircle;
    @ViewChildren('circle', { read: AgmCircle }) listTiendas: QueryList<
        AgmCircle
    >;
    @ViewChildren('storemarked', { read: AgmCircle }) listStoresMarked: QueryList<
        AgmCircle
    >;
    @ViewChildren('czone', { read: AgmCircle }) listSearchZones: QueryList<
        AgmCircle
    >;
    inValidForm = false;
    storeArray: Store = <Store>{};
    storeMarkedArray: Store = <Store>{};
    searchZonesArray: SearchZone = <SearchZone>{};
    initSearch = false;
    public locations = GeneralData.getStores();
    alertDialogRef: MatDialogRef<AppAlertDialogComponent>;
    ubigeo: Ubigeo[] = [];
    departmentsList: Ubigeo[] = [];
    provinces: Ubigeo[] = [];
    districts: Ubigeo[] = [];
    value = 0;
    regForm: FormGroup;
    regFormErrors: any;
    loading = false;
    utmSource = null;
    styles: MapTypeStyle[] = MapStyles.getStyle();
    public latitude: number;
    public longitude: number;
    public zoom: number;
    private geoCoder;
    public currentAddress = '';
    icon = 'assets/images/mkr.png';
    @ViewChild('search')
    public searchElementRef: ElementRef;
    departaments: any[];
    fullscreenControl = true;
    filteredOptions: Observable<Ubigeo[]>;
    filteredOptionsDepartments: Observable<Ubigeo[]>;
    filteredOptionsProvinces: Observable<Ubigeo[]>;
    filteredOptionsDistricts: Observable<Ubigeo[]>;

    private _unsubscribeAll: Subject<any>;
    dialogRef: any;
    public lat: number;
    public lng: number;
    tiendas: any[] = [];
    stores: any[] = [];
    storesMarked: any[] = [];
    searchZones: any[] = [];
    /**
     * Constructor
     *
     * @param {MapsAPILoader} _mapsAPILoader
     * @param {FormBuilder} _formBuilder
     * @param {NgZone} _ngZone
     * @param {LocalStorageService} _storage
     * @param {AppConfigService} _appConfig
     */

    constructor(
        private _mapsAPILoader: MapsAPILoader,
        private _ngZone: NgZone,
        private _storage: LocalStorageService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _appConfig: AppConfigService,
        private _scrollService: ScrollService,
        public dialog: MatDialog,
        private _localService: LocalService
    ) {
        this._appConfig.setSettings({
            layout: {
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.regFormErrors = {
            address: {},
            department: {},
            ubigeo_id: {},
            department_id: {},
            province_id: {},
            local_area: {},
            contact_name: {},
            contact_lastname: {},
            contact_email: {},
            contact_phone: {},
            term: {},
            pp: {},
            ptd: {}
        };

        this.departaments = DataStep1.departaments;
        this._unsubscribeAll = new Subject();
    }

    listCircles(): void {
        this.tiendas = [
            {
                lat: -12.1206101,
                lng: -77.0296392
            },
            {
                lat: -12.1102223,
                lng: -77.02195
            },
            {
                lat: -12.1132662,
                lng: -77.03791309999997
            },
            {
                lat: -12.1031622,
                lng: -77.03640630000001
            },
            {
                lat: -12.0964147,
                lng: -77.02183869999999
            }
        ];
    }
    /**
     * On init
     */
    ngOnInit() {
        (window as any).fbq('track', 'ViewContent');
        
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const utmSourceParam = urlParams.get('utm_source');
        if(utmSourceParam){
            this.utmSource = utmSourceParam;
            localStorage.setItem('utm_source', this.utmSource);
        }

        this.listCircles();
        this.zoom = 15;
        this.lat = -12.1206101;
        this.lng = -77.0296392;
        this.setCurrentPosition();
        this._mapsAPILoader.load().then(() => {
            this.geoCoder = new google.maps.Geocoder();
            const autocomplete = new google.maps.places.Autocomplete(
                this.searchElementRef.nativeElement,
                {
                    types: ['address'],
                    componentRestrictions: { country: 'pe' }
                }
            );
            this.storeArray = <Store>{};
            this.storeMarkedArray = <Store>{};
            this.searchZonesArray = <SearchZone>{};
            this.initSearch = false;
            autocomplete.addListener(
                'place_changed',
                () => {
                    this._ngZone.run(() => {
                        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
                        if (
                            place.geometry === undefined ||
                            place.geometry === null
                        ) {
                            return;
                        }

                        this.latitude = place.geometry.location.lat();
                        this.longitude = place.geometry.location.lng();
                        const formatted_address = place.formatted_address;
                        this.regForm.get('latitud').setValue(this.latitude);
                        this.regForm.get('longitud').setValue(this.longitude);
                        this.regForm.get('address').setValue(formatted_address);
                        this.zoom = 15;
                        this.initSearch = true;
                        const latLng = new google.maps.LatLng(
                            this.latitude,
                            this.longitude
                        );
                        this.validateStore(latLng);
                        this.validateStoreMarked(latLng);
                        this.validateSearchZones(latLng);
                    });
                },
                () => {
                    console.log('yate');
                }
            );
        });
        this.regForm = this._formBuilder.group({
            address: [null, [AppUtils.validateObjectAddress.bind(this)]],
            latitud: [0, Validators.required],
            longitud: [0, Validators.required],
            department: ['1416'],
            ubigeo_id: [null, [AppUtils.validateObjectUbigeo.bind(this)]],
            department_id: [null, [AppUtils.validateObjectUbigeoDepartment.bind(this)]],
            province_id: [null, [AppUtils.validateObjectUbigeoProvince.bind(this)]],
            local_area: [
                '',
                [Validators.required, Validators.pattern(/^[1-9]+[0-9]*$/)]
            ],
            contact_name: ['', Validators.required],
            contact_lastname: ['', Validators.required],
            contact_email: ['', [Validators.required, Validators.email]],
            contact_phone: ['', [Validators.required]],
            term: ['', Validators.required],
            pp: ['', Validators.required],
            ptd: ['', Validators.required]
        });

        this.regForm.valueChanges.subscribe(() => {
            this.onRegisterFormValuesChanged();
            this.inValidForm = false;
            const errors = this.getErrors(this.regForm);
            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    const element = errors[key];
                }
            }

            this.value = this.regForm.get('local_area').value;
        });

        this._localService.ubigeoOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(ubigeo => {
                this.ubigeo = ubigeo;
            });

        this._localService.userOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(user => {
                if (this._storage.retrieve('token')) {
                    this.regForm.patchValue({
                        contact_name: user.name,
                        contact_lastname: user.lastname,
                        contact_email: user.email,
                        contact_phone: (user.phone ? user.phone : null)
                    });
                }
            });

        this._localService.departmentsOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(ubigeo => {
                this.departmentsList = ubigeo;
            });

        this._localService.provincesOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(ubigeo => {
                this.provinces = ubigeo;
            });

        this._localService.districtsOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(ubigeo => {
                this.districts = ubigeo;
            });

        this.filteredOptions = this.regForm.get('ubigeo_id').valueChanges.pipe(
            startWith<string | Ubigeo>(''),
            map(value => (typeof value === 'string' ? value : value.name)),
            map(name => (name ? this._filter(name) : this.ubigeo.slice()))
        );

        this.filteredOptionsDepartments = this.regForm
            .get('department_id')
            .valueChanges.pipe(
                startWith<string | Ubigeo>(''),
                map(value => (typeof value === 'string' ? value : value.name)),
                map(name =>
                    name ? this._filterDepartments(name) : this.departmentsList.slice()
                )
            );

        this.searchZones = this._localService.searchZones;
        this.stores = this._localService.stores.filter(store => !store.flag_marked);
        this.storesMarked = this._localService.stores.filter(store => store.flag_marked);

        this.filter();
    }

    ngAfterViewInit() {
        this._scrollService._init();
    }

    filter() {
        fromEvent(this.searchElementRef.nativeElement, 'keyup')
            .pipe(
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe((value: any) => {
                const val: string = this.searchElementRef.nativeElement.value;

                if (this.initSearch) {
                    this.regForm.get('address').setValue('');
                    this.initSearch = false;
                } else {
                    if (val.length === 0) {
                        this.latitude = 0;
                        this.longitude = 0;
                        this.regForm.get('latitud').setValue(this.latitude);
                        this.regForm.get('longitud').setValue(this.longitude);
                    }
                }
            });
    }

    displayFn(ubigeo?: Ubigeo): string | undefined {
        return ubigeo ? ubigeo.name : undefined;
    }

    displayFnUbigeo(ubigeo?: Ubigeo): string | undefined {
        return ubigeo ? ubigeo.name : undefined;
    }

    displayFnDepartment(ubigeo?: Ubigeo): string | undefined {
        return ubigeo ? ubigeo.name : undefined;
    }

    displayFnProvince(ubigeo?: Ubigeo): string | undefined {
        return ubigeo ? ubigeo.name : undefined;
    }

    displayFnDistrict(ubigeo?: Ubigeo): string | undefined {
        return ubigeo ? ubigeo.name : undefined;
    }

    private _filter(name: string): Ubigeo[] {
        const filterValue = name.toLowerCase();

        return this.ubigeo.filter(
            ubigeo => ubigeo.name.toLowerCase().indexOf(filterValue) === 0
        );
    }

    private _filterDepartments(name: string): Ubigeo[] {
        const filterValue = name.toLowerCase();

        return this.departmentsList.filter(
            ubigeo => ubigeo.name.toLowerCase().indexOf(filterValue) === 0
        );
    }

    private _filterProvinces(name: string): Ubigeo[] {
        const filterValue = name.toLowerCase();

        return this.provinces.filter(
            ubigeo => ubigeo.name.toLowerCase().indexOf(filterValue) === 0
        );
    }

    private _filterDistricts(name: string): Ubigeo[] {
        const filterValue = name.toLowerCase();

        return this.districts.filter(
            ubigeo => ubigeo.name.toLowerCase().indexOf(filterValue) === 0
        );
    }

    onRegisterFormValuesChanged() {
        for (const field in this.regFormErrors) {
            if (!this.regFormErrors.hasOwnProperty(field)) {
                continue;
            }
            this.regFormErrors[field] = {};
            const control = this.regForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.regFormErrors[field] = control.errors;
            }
        }
    }

    getOutOfRange(departmentId){
        let result = {
            outOfRange: false,
            name: ''
        };
        this.departmentsList.forEach(ubigeo => {
            if(ubigeo.id == departmentId.id){
                result.outOfRange = ubigeo.in_range;
                result.name = ubigeo.name;
            }
        });
        return result;
    }

    onSubmit() {
        if (this.regForm.valid) {
            this.loading = true;

            const data = this.regForm.getRawValue();
            const urmSourceStorage = localStorage.getItem('utm_source');
            if(this.utmSource || (urmSourceStorage && urmSourceStorage != '')){
                data.utm_source = this.utmSource?this.utmSource:urmSourceStorage;
            }
            const ubigeo = this.regForm.get('ubigeo_id').value;
            data.ubigeo_id = ubigeo.id;

            const local_area = Number(this.regForm.get('local_area').value);
            let departmentItem = this.regForm.get('department_id').value;
            data.flag_status = local_area >= MIN_LOCAL_AREA ? 1 : 0;
            data.flag_store = !this.isEmpty(this.storeArray) ? 1 : 0;
            data.flag_store_marked = !this.isEmpty(this.storeMarkedArray) ? 1 : 0;
            data.flag_searchzone = !this.isEmpty(this.searchZonesArray) ? 1 : 0;
            data.flag_in_range = departmentItem.in_range ? 1 : 0 ;
            data.flag_priority = ( data.flag_status && data.flag_in_range && !data.flag_store && (data.flag_searchzone || data.flag_store_marked) ) ? 1 : 0;
            // if (!this.isEmpty(this.storeArray)) {
            //     data.flag_status = 0;
            // }

            if (local_area >= MIN_LOCAL_AREA) {
                data.steps = -1;
            }

            (window as any).fbq('track', 'Subscribe');

            this._localService.add(data).subscribe(
                (res: any) => {
                    this.loading = false;
                    const _data = res.data;
                    let redirect = false;

                    (window as any).fbq('track', 'CompleteRegistration');

                    if(local_area >= MIN_LOCAL_AREA) {
                        if(data.flag_in_range && !data.flag_store){
                            redirect = true;
                        }
                        // if(!data.flag_in_range){
                        //     // this.alert(
                        //     //     `Estimado Propietario; Muchas gracias por ofrecernos su local en alquiler. 
                        //     //     En este momento no estamos evaluando la ciudad de ${departmentItem.name}, 
                        //     //     sin embargo estamos guardando su registro para una nueva oportunidad. Saludos.`
                        //     // );
                        // }
                        // else if(data.flag_store){
                        //     // this.alert(
                        //     //     `Estimado Propietario: Muchas gracias por ofrecernos su local en alquiler. 
                        //     //     En este momento no estaramos Interesados en avanzar con su local, 
                        //     //     sin embargo estamos guardando su registro para una nueva oportunidad.`
                        //     // );
                        // }
                        // else{
                        //     redirect = true;
                        // }
                    }
                    else{
                      if(data.flag_searchzone){
                        redirect = true;
                        // this.alert(
                        //     `Estimado Propletario: Muchas gracias por ofrecernos su local en alquiler, En este
                        //     momento estamos buscando locales a partir de 180 m2. Sin embargo, estamos
                        //     guardando su registro para mas adelante. Saludos.`
                        // );
                      } 
                      else{
                        // this.alert(
                        //     `Estimado Propietario; Muchas gracias por ofrecernos su local en alquiler, En este
                        //     momento estamos buscando locales a partir de 180 m2. Sin embargo, estamos
                        //     guardando su registro para mas adelante. Saludos.`
                        // );
                      } 
                    }

                    if(redirect){
                        this._storage.store('lead', _data);
                        this._storage.store('code', _data.code);
                        this._router.navigate(['/local/registro/1/gracias']);
                    }
                    else{
                        this.alert('Estimado Propietario, gracias por su registro. Estaremos evaluando la información brindada y nos comunicaremos con usted en caso nos decidamos avanzar con su inmueble.');
                    }

                },
                (err: any) => {
                    this.loading = false;
                    if (!Boolean(err.status)) {
                        const msg = AppUtils.showErrors(err.data);
                        if (msg !== '') {
                            this.alert(msg, false);
                        }
                    } else {
                        this.alert(
                            'Ocurrió un error, inténtalo nuevamente.',
                            false
                        );
                    }
                }
            );
        }
    }

    /**
     * Set current position
     */

    private setCurrentPosition() {
        /*
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.zoom = 15;
          });
        }
        */

        this.latitude = -11.9540103;
        this.longitude = -77.0433898;
        this.zoom = 15;
    }

    /**
     * Move Drag End Marker Google Maps
     * @param $event
     */

    markerDragEnd($event: any) {
        this.latitude = $event.coords.lat;
        this.longitude = $event.coords.lng;
        this.storeArray = <Store>{};
        this.storeMarkedArray = <Store>{};
        this.searchZonesArray = <SearchZone>{};
        this.geoCoder.geocode(
            {
                location: { lat: this.latitude, lng: this.longitude }
            },
            (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        this.currentAddress = results[0].formatted_address;
                        this.searchElementRef.nativeElement.value =
                            results[0].formatted_address;
                        this.latitude = results[0].geometry.location.lat();
                        this.longitude = results[0].geometry.location.lng();

                        this.regForm.get('latitud').setValue(this.latitude);
                        this.regForm.get('longitud').setValue(this.longitude);
                        this.regForm
                            .get('address')
                            .setValue(this.currentAddress);

                        const latLng = new google.maps.LatLng(
                            this.latitude,
                            this.longitude
                        );

                        this.validateStore(latLng);
                        this.validateStoreMarked(latLng);
                        this.validateSearchZones(latLng);
                    } else {
                        this.setInitInputSearch();
                        window.alert('No results found');
                    }
                } else {
                    this.setInitInputSearch();
                    window.alert('Geocoder failed due to: ' + status);
                }
            }
        );
    }
    setInitInputSearch(): void {
        this.initSearch = false;
        this.regForm.get('latitud').setValue(0);
        this.regForm.get('longitud').setValue(0);
        this.regForm.get('address').setValue('');
    }

    getBounds(store: AgmCircle) {
        return new Promise((resolve, reject) => {
            resolve(store.getBounds().then((res: LatLngBounds) => res));
        });
    }

    caculateDistance(): void {
        const a = new google.maps.LatLng(this.lat, this.lng);
        const b = new google.maps.LatLng(this.latitude, this.longitude);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(
            a,
            b
        );
        const result = parseInt(distance, 0) - 450;
    }

    validateStore(latLng: any) {
        this.listTiendas.map((store: AgmCircle) => {
            store.getBounds().then((res: LatLngBounds) => {
                if (res.contains(latLng)) {
                    this.storeArray = {
                        latitude: store.latitude,
                        longitude: store.longitude
                    };
                }
            });
        });
    }

    validateStoreMarked(latLng: any): void {
        this.listStoresMarked.map((store: AgmCircle) => {
            store.getBounds().then((res: LatLngBounds) => {
                if (res.contains(latLng)) {
                    this.storeMarkedArray = {
                        latitude: store.latitude,
                        longitude: store.longitude
                    };
                }
            });
        });
    }

    validateSearchZones(latLng: any): void {
        this.listSearchZones.map((searchZone: AgmCircle) => {
            searchZone.getBounds().then((res: LatLngBounds) => {
                if (res.contains(latLng)) {
                    this.searchZonesArray = {
                        latitude: searchZone.latitude,
                        longitude: searchZone.longitude
                    };
                }
            });
        });
    }

    searchAddress() {
        this.geoCoder.geocode(
            {
                address: this.searchElementRef.nativeElement.value
            },
            function (results, status) {
                if (
                    status === google.maps.GeocoderStatus.OK &&
                    results.length > 0
                ) {
                    const address = results[0].formatted_address;
                } else {
                    console.log('direccion no encontrada');
                }
            }
        );
    }
    numUpdown(e: number) {
        this.regForm.get('local_area').setValue(e);
    }

    /*  address */
    get address() {
        return this.regForm.get('address');
    }
    get address_value(): number {
        const _value: string = this.address.value;
        if (_value === null) {
            return 0;
        }
        return _value.length;
    }

    /*  ubigeo_id */
    get ubigeo_id() {
        return this.regForm.get('ubigeo_id');
    }

    /*  department_id */
    get department_id(): AbstractControl {
        return this.regForm.get('department_id');
    }
    
    /*  province_id */
    get province_id(): AbstractControl {
        return this.regForm.get('province_id');
    }

    /*  latitud */
    get latitud() {
        return this.regForm.get('latitud');
    }
    get latitud_value(): boolean {
        const _value = String(this.latitud.value);
        return _value.length > 0 ? true : false;
    }

    /*  longitud */
    get longitud() {
        return this.regForm.get('longitud');
    }
    get longitud_value(): boolean {
        const _value = String(this.longitud.value);
        return _value.length > 0 ? true : false;
    }

    /*  local_area */
    get local_area() {
        return this.regForm.get('local_area');
    }
    get local_area_value(): boolean {
        const _value = String(this.local_area.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_name */
    get contact_name() {
        return this.regForm.get('contact_name');
    }
    get contact_name_value(): boolean {
        const _value = String(this.contact_name.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_lastname */
    get contact_lastname() {
        return this.regForm.get('contact_lastname');
    }
    get contact_lastname_value(): boolean {
        const _value = String(this.contact_lastname.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_email */
    get contact_email() {
        return this.regForm.get('contact_email');
    }
    get contact_email_value(): boolean {
        const _value = String(this.contact_email.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_phone */
    get contact_phone() {
        return this.regForm.get('contact_phone');
    }
    get contact_phone_value(): boolean {
        const _value = String(this.contact_phone.value);
        return _value.length > 0 ? true : false;
    }

    get term() {
        return this.regForm.get('term');
    }

    get term_value(): boolean {
        const _value = String(this.term.value);
        return _value.length > 0 ? true : false;
    }

    get pp() {
        return this.regForm.get('pp');
    }

    get pp_value(): boolean {
        const _value = String(this.pp.value);
        return _value.length > 0 ? true : false;
    }

    onFilterTermChange($event) {
        const checked = Boolean($event.target.checked);
        this.regForm.get('term').setValue(Boolean(checked) ? 1 : '');
    }
    onFilterPpChange($event) {
        const checked = Boolean($event.target.checked);
        this.regForm.get('pp').setValue(Boolean(checked) ? 1 : '');
    }

    alert(msg: string, redirect = true) {
        this.alertDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.alertDialogRef.componentInstance.alertMessage = msg;

        this.alertDialogRef.afterClosed().subscribe(result => {
            if (redirect) {
                this._router.navigate(['/']);
            }
            this.alertDialogRef = null;
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    isEmpty(obj): boolean {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    privacity(type): void {

        this.dialogRef = this.dialog.open(AppFormPrivacityComponent, {
            panelClass: 'privacity-form-dialog',
            data: {
                action: type
            }
        });
        this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
            if (!response) {
                return;
            }
        });

    }
    getErrors(formGroup: FormGroup, errors: any = {}) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                errors[field] = control.errors;
            } else if (control instanceof FormGroup) {
                errors[field] = this.getErrors(control);
            }
        });
        return errors;
    }

    changeDeparment(value: any){
        let id = null;
        if(value){
            id = value.id
        }
        this._localService.getProvinces(id).then(()=>{
            this.filteredOptionsProvinces = this.regForm
            .get('province_id')
            .valueChanges.pipe(
                startWith<string | Ubigeo>(''),
                map(value => (typeof value === 'string' ? value : value.name)),
                map(name =>
                    name ? this._filterProvinces(name) : this.provinces.slice()
                )
            );
        });
    }

    changeDistrict(value: any){
        let id = null;
        let departmentId = null;
        if(value){
            id = value.id
            departmentId = this.regForm.get('department_id').value.id;
        }
        this._localService.getDistricts(departmentId, id).then(()=>{
            this.filteredOptionsDistricts = this.regForm
            .get('ubigeo_id')
            .valueChanges.pipe(
                startWith<string | Ubigeo>(''),
                map(value => (typeof value === 'string' ? value : value.name)),
                map(name =>
                    name ? this._filterDistricts(name) : this.districts.slice()
                )
            );
        });
    }
}
